var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListenMetricIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 16,
    viewBox: "0 0 48 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29883 15C12.1647 15 15.2988 11.8658 15.2988 8C15.2988 4.1343 12.1648 1.00101 8.29883 1V15ZM8.29883 15C4.43299 15 1.29883 11.8658 1.29883 8M8.29883 15L1.29883 8M1.29883 8C1.29883 4.13419 4.43292 1.00007 8.29871 1L1.29883 8Z",
    stroke: "#00B2AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23828 4.45996V11.5391L12.504 7.55529L6.23828 4.45996Z",
    fill: "#00B2AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5839 3.21582H20.4277V13.5312H21.5839V3.21582Z",
    fill: "#00B2AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9511 5.0918H24.7949V11.6567H25.9511V5.0918Z",
    fill: "#00B2AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4658 5.0918H37.3096V11.6567H38.4658V5.0918Z",
    fill: "#BEBEBE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3202 3.21582H29.1641V13.5312H30.3202V3.21582Z",
    fill: "#00B2AD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8339 3.21582H41.6777V13.5312H42.8339V3.21582Z",
    fill: "#BEBEBE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6884 5.0918H33.5322V11.6567H34.6884V5.0918Z",
    fill: "#00B2AD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2021 5.0918H46.0459V11.6567H47.2021V5.0918Z",
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListenMetricIcon);
export default __webpack_public_path__ + "static/media/listen-metric-icon.64d9c263aea223fc26ea32788b34c446.svg";
export { ForwardRef as ReactComponent };